import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

// Import your reducers
import currentUserReducer from './reducer/currentUserSlice';
import customersReducer from './reducer/customersSlice';
import departmentsSlice from './reducer/departmentsSlice';
import HRReducer from './reducer/hrSlice';
import inventoryReducer from './reducer/inventorySlice';
import purchaseDateReducer from './reducer/orderPurchaseDate';
import ordersReducer from "./reducer/ordersSlice";
import paymentReducer from './reducer/paymentSlice';
import productsReducer from './reducer/productsSlice';
import purchaseOrderReducer from './reducer/purchaseOrderSlice';
import rawInventoryReducer from './reducer/rawInventorySlice';
import rawItemsReducer from './reducer/rawItemsSlice';
import recipeSlice from './reducer/recipeSlice';
import supplierSlice from './reducer/supplierSlice';
import trayReducer from './reducer/traysSlice';
import usersSlice from './reducer/usersSlice';
import levelSlice from './reducer/levelSlice';

// Combine your reducers
const rootReducer = combineReducers({
  customers: customersReducer,
  HR: HRReducer,
  products: productsReducer,
  orders: ordersReducer,
  currentUser: currentUserReducer,
  users: usersSlice,
  payment: paymentReducer,
  inventory: inventoryReducer,
  rawInventory: rawInventoryReducer,
  tray: trayReducer,
  recipe: recipeSlice,
  supplier: supplierSlice,
  purchaseOrder: purchaseOrderReducer,
  purchase: purchaseDateReducer,
  rawItems: rawItemsReducer,
  accountLevels: levelSlice,
  departments: departmentsSlice
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['currentUser', 'users'] // Add the slices you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Persistor
export const persistor = persistStore(store);
